/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_ThinkingInputs */

const en_us2_chat_thinking = /** @type {(inputs: Chat_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writing the answer…`)
};

const pt_br2_chat_thinking = /** @type {(inputs: Chat_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escrevendo a resposta…`)
};

const es_419_chat_thinking = /** @type {(inputs: Chat_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribiendo la respuesta…`)
};

const pt_pt2_chat_thinking = /** @type {(inputs: Chat_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A escrever a resposta…`)
};

const fr_fr2_chat_thinking = /** @type {(inputs: Chat_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rédaction de la réponse…`)
};

const de_de2_chat_thinking = /** @type {(inputs: Chat_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwort wird geschrieben…`)
};

const it_it2_chat_thinking = /** @type {(inputs: Chat_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sto scrivendo la risposta…`)
};

/**
* | output |
* | --- |
* | "Writing the answer…" |
*
* @param {Chat_ThinkingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const chat_thinking = /** @type {((inputs?: Chat_ThinkingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_ThinkingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_chat_thinking(inputs)
	if (locale === "es-419") return es_419_chat_thinking(inputs)
	if (locale === "pt-PT") return pt_pt2_chat_thinking(inputs)
	if (locale === "fr-FR") return fr_fr2_chat_thinking(inputs)
	if (locale === "de-DE") return de_de2_chat_thinking(inputs)
	if (locale === "it-IT") return it_it2_chat_thinking(inputs)
	return en_us2_chat_thinking(inputs)
});
export { chat_thinking as "chat.thinking" }